import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import CustomButton from 'components/buttons/CustomButton';
import Dummy from 'components/Dummy';
import { requester } from 'App';

const OrderRequestTable = ({ orders }) => {

  const [orderList, setOrderList] = useState();
  useEffect(() => {
    if(orders){
      setOrderList(orders);
    }
  },[orders])
  useEffect(() => {
    
  },[orderList])
  const onClick = (data) => {
    
    requester.approveOrderRequests(data, (result) => {      
      
      setOrderList(result.data);
    })
  }
  return (
    <Box sx={{ margin: 2 }}>
      {orderList && orderList.map((order) => (
        <Box key={order.id} sx={{ marginBottom: 4 }}>
          <Typography variant="h6" gutterBottom>
            주문 아이디: {order.vendorName}
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="order details">
              <TableHead>
                <TableRow>
                  <TableCell>Product Name</TableCell>
                  <TableCell align="right">Quantity</TableCell>
                  <TableCell align="right">Price</TableCell>
                  <TableCell align="right">Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.orderRequestProducts.map((product) => (
                  <TableRow key={product.id}>
                    <TableCell component="th" scope="row">
                      {product.productName}
                    </TableCell>
                    <TableCell align="right">{product.requestQuantity}</TableCell>
                    <TableCell align="right">{product.price}</TableCell>
                    <TableCell align="right">{product.price * product.requestQuantity}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

          </TableContainer>
          <Dummy height={"15px"} />
          {
            order.deliveryType === "WaitingForPayment" 
            ?

            <CustomButton text={"발주승인"} onClick={() => onClick(order)} />
            :
            <CustomButton text={"완료"} />
          }

        </Box>
      ))}

    </Box>
  );
};

export default OrderRequestTable;